import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import {
  header,
  navBar,
  logo_nav_container,
  button_header,
  header_out,
  active_white,
  menu_fijo,
  menu_fijo_out,
} from "../header.module.scss";
import Logo from "./logo";

const DesktopHeader = () => {
  const [activePlacas, setActivePlacas] = useState(false);
  const [activeBlog, setActiveBlog] = useState(false);
  const [activeDoggipedia, setActiveDoggipedia] = useState(false);
  const [hideBlackNav, setHideBlackNav] = useState(false);

  useEffect(() => {
    const changeNavColor = () => {
      if (window.scrollY < (5 * window.innerHeight) / 100) {
        setHideBlackNav(false);
      } else {
        setHideBlackNav(true);
      }
    };
    const isActive = () => {
      const currentURL = window.location.href;
      if (currentURL.indexOf("0perrosperdidos") > -1) {
        setActivePlacas(true);
      } else if (currentURL.indexOf("blog-para-perros") > -1) {
        setActiveBlog(true);
      } else if (currentURL.indexOf("razas-de-perro") > -1) {
        setActiveDoggipedia(true);
      }
    };
    isActive();
    window.addEventListener("scroll", changeNavColor);
  }, []);

  return (
    <header className={hideBlackNav ? header_out : header}>
      <nav className={hideBlackNav ? menu_fijo_out : menu_fijo}>
        <Link
          id="razas-de-perro"
          to="/razas-de-perro"
          className={activeDoggipedia && active_white}
        >
          Conoce a tu perro
        </Link>

        <Link
          id="blog"
          to="/blog-para-perros"
          className={activeBlog && active_white}
        >
          Blog
        </Link>
        {/* <Link
          id="0perrosperdidos"
          to="/0perrosperdidos"
          className={activePlacas && active_white}
        >
          #0perrosperdidos
        </Link> */}
      </nav>
      <div className={navBar}>
        <div>
          <Link id="logo" to="/">
            <Logo />
          </Link>
        </div>
        <nav className={logo_nav_container}>
          <Link to="/reserva-collar-kolyy">
            <button id="compra" className={button_header}>
              <b>Reserva tu collar</b>
            </button>
          </Link>
        </nav>
      </div>
    </header>
  );
};

DesktopHeader.propTypes = {
  siteTitle: PropTypes.string,
};

export default DesktopHeader;
